export default __webpack_public_path__ + "static/media/javascriptpix.b0b3003f.jpg";